<template>
  <b-container class="mt-5">
    <b-row>
      <b-col offset="0" cols="12" offset-md="3" md="6">
        <registration-form />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RegistrationForm from '../components/RegistrationForm'

export default {
  components: {
    RegistrationForm
  },
}
</script>